<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <div class="box has-text-justified vip-box">
                <div class="content">
                    <b>DESTACABLE</b>
                    <ol>
                        <li>Bono de 10% de experiencia dentro del juego.</li>
                        <li>El sistema Anti-Afk ya no te molestará.</li>
                    </ol>
                </div>
                <div class="content">
                    <b>RESET</b>
                    <ol>
                        <li>Puedes realizar un Reset a nivel 400.</li>
                        <li>5 créditos adicionales cuando obtienes un Reset (15 en total).</li>
                        <li>50% de descuento zen en el precio de los Reset.</li>
                        <li>150 puntos de nivel adicionales al hacer un Reset (650 en total).</li>
                        <li>Con 90 resets puedes hacer el Grandreset.</li>
                        <li>2000 créditos adicionales cuando obtienes un Grandreset (12000 en total).</li>
                        <li>50% de descuento zen en el precio de los Grandreset.</li>
                        <li>2000 puntos de nivel adicionales al hacer un Grandreset (12000 en total).</li>
                    </ol>
                </div>
                <div class="content">
                    <b>MAPAS</b>
                    <ol>
                        <li>Nuevo mapa Crisis solo para VIP.</li>
                        <li>Nuevo 'move' a Arena.</li>
                        <li>Acceso a los siguientes mapas.
                            <ul>
                                <li>Davias 2, 3 y 4. <code>/move davias3</code></li>
                                <li>Calabozo. <code>/move calabozo</code></li>
                                <li>Losttower 2, 4 y 6. <code>/move losttower6</code></li>
                                <li>Atlans 2 y 3. <code>/move atlans2</code></li>
                                <li>Tarkan 2. <code>/move tarkan2</code></li>
                                <li>Icarus 2. <code>/move icarus2</code></li>
                                <li>Arena. <code>/move arena</code></li>
                                <li>Crisis, Crisis 2 y 3. <code>/move crisis</code></li>
                            </ul>
                        </li>
                        
                    </ol>
                </div>
                <div class="content">
                    <b>RANKING</b>
                    <ol>
                        <li>Emblema destacable para tu personaje en el Ranking.</li>
                        <li>Borde especial VIP para tu posición en el Ranking.</li>
                    </ol>
                </div>
        </div>

    </div>

  </div>
</template>

<script>
export default {
    name:'VipProfitModal',
    props: {
        show: {
            default:false,
            type:Boolean
        }
    }
}
</script>

<style scoped>
    .vip-box {
        overflow-y: auto;
        max-height: calc(100vh - 225px) !important;;
    }
</style>